import { IS_MOBILE_APP } from '../../constants/isMobileApp';
import { TAnalyticEventNames } from './types';

// eslint-disable-next-line no-multi-assign
const dataLayer = (window.dataLayer = window.dataLayer || []);

export function trackEvent(
  name: TAnalyticEventNames,
  params?: Record<string, string | boolean | number | undefined>
) {
  const evt = {
    event: name,
    timestamp: new Date().getTime(),
    ...params,
  };
  window.analytics?.trackEvent?.(evt);
  dataLayer.push(evt);
}

export function trackPageView(url: string, punterId?: string) {
  if (IS_MOBILE_APP || !url) return;
  const evt = {
    event: 'page_view',
    url,
    punterId,
  };
  window.analytics?.trackEvent?.(evt);
  dataLayer.push(evt);
}

export function trackUser(
  punterId: string | null | undefined,
  punterEmail: string | null | undefined
) {
  if (IS_MOBILE_APP) return;

  if (punterId && punterEmail) {
    dataLayer.push({
      punterId,
      punterEmail,
    });
  }
}

export function resetAnalytics() {
  dataLayer.push({
    punterId: undefined,
    punterEmail: undefined,
  });
  window.analytics?.reset?.();
}
